import axios from 'axios';
import authHeader from "@/service/auth-header";

class UserService {
    async getUser(userId) {
        return await axios.get(`/api/user/${userId}`, {headers: authHeader()})
    }

    async getUserConfig(userId) {
        // console.log("[UserService][getUserConfig] Getting user configuration for user = ", userId);

        return await axios.get(`/api/user/config/${userId}`, {headers: authHeader()})
    }

    async getCompanyUsers(companyId) {
        return await axios.get(`/api/user/company/${companyId}`, {headers: authHeader()})
    }

    searchCompanyUsers(companyId, userFirstName) {
        return axios.get(`/api/user/${companyId}/${userFirstName}`, {headers: authHeader()})
    }

    async getAllUsers() {
        return await axios.get(`/api/user`, {headers: authHeader()})
    }

    async getUserPing() {
        return await axios.get(`/api/user/ping`)
    }

    async updateUserConfig(userId, data) {
        // console.log("[UserService][updateUserConfig] Before making PUT call. Data = ", data);
        return await axios.put(`/api/user/config/${userId}`, data, {headers: authHeader()})
    }

    async getUsersByLastName(lastName) {
        return await axios.get(`/api/user/search/${lastName}`, {headers: authHeader()})
    }

    async updateUser(userId, data) {
        // console.log("[UserService][updateUser] Before making PUT call. Data = ", data);
        return await axios.put(`/api/user/${userId}`, data, {headers: authHeader()})
    }

    async upgradeToIsoEvolve(userId) {
        // console.log("[UserService][upgradeToIsoEvolve] Before making POST call. URL = /api/user/upgrade/" + userId);

        return await axios.post(`/api/user/upgrade/${userId}`, null, {headers: authHeader()})

    }

    async resetPassword(email) {
        // console.log("[UserService][updateUserConfig] Before making PUT call. Data = ", data);
        return await axios.post(`/api/user/resetpassword/${email}`, null, {headers: authHeader()})
    }

    async resetPasswordActivation(email, password) {
        // console.log("[UserService][updateUserConfig] Before making PUT call. Data = ", data);
        return await axios.post(`/api/user/resetpasswordactivation/${email}/${password}`, null, {headers: authHeader()})
    }



}

export default new UserService();
